<template>
  <div>
    <section class="hero hero-page gray-bg padding-small">
      <div class="container">
        <div class="row d-flex">
          <div class="col-lg-9 order-2 order-lg-1">
            <h1>{{ $t(mode) }} {{ localize(props.style.names) }}</h1>
            <div v-if="isAuthenticated" class="list-inline-item mt-3">
              <FavoriteButton
                :is-favorite="isFavorite"
                item-type="grab-bag"
                :item-id="catalogProductId"
                :xsrf-token="xsrfToken"
                @toggle="toggleFavorite"
              />
            </div>
          </div>
          <div class="col-lg-3 text-right order-1 order-lg-2">
            <ul class="breadcrumb justify-content-lg-end">
              <li class="breadcrumb-item">
                <a href="/">{{ $t('Home') }}</a>
              </li>
              <li class="breadcrumb-item">
                <a :href="isGrabBag ? '/grab-bag' : '/overstock'">{{
                  $t(mode)
                }}</a>
              </li>
              <li class="breadcrumb-item active">
                {{ $t(mode) }} {{ localize(props.style.names) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="product-details">
      <div class="container">
        <div class="row">
          <div class="product-images col-lg-6">
            <div class="ribbon-info text-uppercase">{{ $t(mode) }}</div>
            <div data-slider-id="1" class="owl-carousel items-slider owl-drag">
              <div class="item">
                <img
                  :src="imgUrl('front')"
                  onerror="this.src = '/images/comingsoon.png'"
                  :alt="`${$t(mode)} ${localize(props.style.names)} ${$t(
                    'Front',
                  )}`"
                />
              </div>
              <div class="item">
                <img
                  :src="imgUrl('back')"
                  onerror="this.src = '/images/comingsoon.png'"
                  :alt="`${$t(mode)} ${localize(props.style.names)} ${$t(
                    'Back',
                  )}`"
                />
              </div>
            </div>
            <div
              data-slider-id="1"
              class="owl-thumbs d-flex align-items-center justify-content-center"
            >
              <button class="owl-thumb-item">
                <img
                  :src="imgUrl('front')"
                  onerror="this.src = '/images/comingsoon.png'"
                  :alt="`${$t(mode)} ${localize(props.style.names)} ${$t(
                    'Front',
                  )} ${$t('Thumbnail')}`"
                />
              </button>
              <button class="owl-thumb-item">
                <img
                  :src="imgUrl('back')"
                  onerror="this.src = '/images/comingsoon.png'"
                  :alt="`${$t(mode)} ${localize(props.style.names)} ${$t(
                    'Back',
                  )} ${$t('Thumbnail')}`"
                />
              </button>
            </div>
          </div>
          <div class="details col-lg-6">
            <div
              class="d-flex align-items-center justify-content-between flex-column flex-sm-row"
            >
              <ul
                v-if="!isProductUnavailable"
                class="price list-inline no-margin"
              >
                <li class="list-inline-item current">
                  {{ asCurrency(data.product.customerPrice.amount) }}
                  <small v-if="showDisplayCurrency"
                    >{{
                      asDisplayCurrency(
                        data.product.customerPrice.amount * displayExchangeRate,
                      )
                    }}<sup>1</sup></small
                  >
                </li>
                <li
                  v-if="
                    data.product.retailPrice.amount !==
                    data.product.customerPrice.amount
                  "
                  class="list-inline-item original"
                >
                  <s>{{ asCurrency(data.product.retailPrice.amount) }}</s>
                  <small v-if="showDisplayCurrency"
                    ><s>{{
                      asDisplayCurrency(
                        data.product.retailPrice.amount * displayExchangeRate,
                      )
                    }}</s
                    ><sup>1</sup></small
                  >
                </li>
              </ul>
            </div>
            <p>{{ $t(message) }}</p>
            <form id="cartForm" action="/cart/add" method="post">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <span v-html="props.xsrfTokenInput"></span>
              <input
                v-model="data.recaptchaToken"
                type="hidden"
                name="g-recaptcha-response"
              />
              <div class="d-flex align-items-center justify-content-around">
                <ul class="list-inline">
                  <li class="list-inline-item">
                    <h4>{{ $t('Fabric') }}</h4>
                  </li>
                  <li class="list-inline-item">
                    <select
                      v-model="data.fabricId"
                      :class="{ 'is-invalid': fabricId === 'unk' }"
                      class="form-control"
                      size="1"
                      @change="updateProduct()"
                    >
                      <option v-if="props.fabrics.length !== 1" value="unk">
                        {{ $t('Select fabric') }}
                      </option>
                      <option
                        v-for="fabric in props.fabrics"
                        :key="fabric.id"
                        :value="fabric.agonswimId"
                        :selected="props.fabrics.length === 1"
                      >
                        {{ localize(fabric.names) }}
                      </option>
                    </select>
                    <div class="invalid-feedback">
                      {{ $t('Please select a fabric.') }}
                    </div>
                  </li>
                </ul>
              </div>
              <div class="d-flex align-items-center justify-content-around">
                <ul class="list-inline">
                  <li class="list-inline-item">
                    <h4>{{ $t('Lining') }}</h4>
                  </li>
                  <li class="list-inline-item form-group">
                    <select
                      v-model="data.liningId"
                      :class="{ 'is-invalid': liningId === 'unk' }"
                      class="form-control"
                      size="1"
                      @change="updateProduct()"
                    >
                      <option
                        v-if="props.liningOptions.length !== 1"
                        value="unk"
                      >
                        {{ $t('Select lining') }}
                      </option>
                      <option
                        v-for="liningOption in props.liningOptions"
                        :key="liningOption.oldId"
                        :value="liningOption.oldId"
                        :selected="props.liningOptions.length === 1"
                      >
                        {{ localize(liningOption.names) }}
                      </option>
                    </select>
                    <div class="invalid-feedback">
                      {{ $t('Please select a lining option.') }}
                    </div>
                  </li>
                </ul>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <h4 class="text-center">{{ $t('Quantity') }}</h4>
                  <div v-if="!isProductUnavailable" class="row">
                    <div
                      v-for="size in orderBy(
                        data.product.product.sizes || [],
                        'order',
                      )"
                      :key="size.id"
                      class="col-6 col-md-4"
                    >
                      <div class="form-group">
                        <label :for="'size' + size.id" class="text-center"
                          >{{ $t('Size') }} {{ size.values.agon }}
                          <span v-if="isSalesRep"
                            >(Inv
                            {{
                              isSalesRep &&
                              inventory[catalogProductId + size.id]
                            }})</span
                          ></label
                        >
                        <select
                          v-if="
                            data.quantities[catalogProductId + size.id] &&
                            data.quantities[catalogProductId + size.id]
                              .showDropdown
                          "
                          :id="'quantities[' + catalogProductId + size.id + ']'"
                          v-model.number="
                            data.quantities[catalogProductId + size.id].qty
                          "
                          :name="
                            'quantities[' + catalogProductId + size.id + ']'
                          "
                          class="form-control"
                          size="1"
                          @change="updateQuantity()"
                        >
                          <option
                            v-for="option in qtyOptions"
                            :key="option.value"
                            :value="option.value"
                          >
                            {{ option.text }}
                          </option>
                        </select>
                        <input
                          v-if="
                            data.quantities[catalogProductId + size.id] &&
                            data.quantities[catalogProductId + size.id]
                              .showDropdown === false
                          "
                          :id="
                            'data.quantities[' +
                            catalogProductId +
                            size.id +
                            ']'
                          "
                          v-model.number="
                            data.quantities[catalogProductId + size.id].qty
                          "
                          style="display: inline"
                          size="5"
                          type="number"
                          min="0"
                          step="1"
                          :name="
                            'data.quantities[' +
                            catalogProductId +
                            size.id +
                            ']'
                          "
                          class="form-control"
                          @change="updateQuantity()"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="isProductUnavailable" class="row">
                    <div class="col-md-12">
                      <h4>
                        {{
                          $t(
                            'This product is not available. Please select another fabric or lining.',
                          )
                        }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <ul class="CTAs list-inline">
                <li class="list-inline-item">
                  <button
                    type="button"
                    class="btn btn-template wide form-control"
                    :class="{ 'is-invalid': isSubmitDisabled }"
                    :disabled="isSubmitDisabled"
                    @click="recaptcha"
                  >
                    <i class="icon-cart"></i> {{ $t('Add to cart') }}
                  </button>
                  <div class="invalid-feedback">
                    {{ $t('Please select at least one size.') }}
                  </div>
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
    </section>
    <section class="product-description no-padding">
      <div class="container">
        <ul role="tablist" class="nav nav-tabs">
          <li class="nav-item">
            <a
              data-toggle="tab"
              href="#style-detail"
              role="tab"
              class="nav-link active"
              >{{ $t('Style Details') }}</a
            >
          </li>
          <li class="nav-item">
            <a
              data-toggle="tab"
              href="#lining-detail"
              role="tab"
              class="nav-link"
              >{{ $t('Lining Details') }}</a
            >
          </li>
          <li class="nav-item">
            <a
              data-toggle="tab"
              href="#fabric-detail"
              role="tab"
              class="nav-link"
              >{{ $t('Fabric Details') }}</a
            >
          </li>
          <li class="nav-item">
            <a
              data-toggle="tab"
              href="#size-detail"
              role="tab"
              class="nav-link"
              >{{ $t('Size Details') }}</a
            >
          </li>
          <li class="nav-item">
            <a
              data-toggle="tab"
              href="#piece-detail"
              role="tab"
              class="nav-link"
              >{{ $t('Piece Details') }}</a
            >
          </li>
        </ul>
        <div class="tab-content">
          <div id="style-detail" role="tabpanel" class="tab-pane active">
            <h4>{{ localize(props.style.names) }}</h4>
            <p>{{ localize(props.style.descriptions) }}</p>
          </div>
          <div id="lining-detail" role="tabpanel" class="tab-pane">
            <div v-for="lining in props.liningOptions" :key="lining.oldId">
              <h4>{{ localize(lining.names) }}</h4>
              <p>{{ localize(lining.descriptions) }}</p>
            </div>
          </div>
          <div id="fabric-detail" role="tabpanel" class="tab-pane">
            <div v-for="fabric in props.fabrics" :key="fabric.id">
              <FabricSummary
                :blob-domain="props.blobDomain"
                :fabric="fabric"
                :culture="props.culture"
              ></FabricSummary>
            </div>
          </div>
          <div id="size-detail" role="tabpanel" class="tab-pane">
            <div class="row">
              <div v-if="data.product && data.product.product">
                <div
                  v-if="data.product.product.showSizeCalculator"
                  class="col-md-6 col-12"
                >
                  <SizeCalculator
                    :assembly="assembly"
                    :product="data.product.product"
                    :culture="props.culture"
                  ></SizeCalculator>
                </div>
                <div v-else class="col-md-6 col-12">
                  <SizeDetail
                    :assembly="assembly"
                    :product="data.product.product"
                    :culture="props.culture"
                  ></SizeDetail>
                </div>
              </div>
            </div>
          </div>
          <div id="piece-detail" role="tabpanel" class="tab-pane">
            <PiecesDetail
              v-if="data.product"
              :assembly="assembly"
              :product="data.product.product"
              :culture="props.culture"
            ></PiecesDetail>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed, onBeforeMount } from 'vue';
import { useReCaptcha } from 'vue-recaptcha-v3';
import { orderBy } from 'lodash-es';
import { localize as genLocalize } from '../../common/localize';
import SizeCalculator from '../../components/SizeCalculator.vue';
import SizeDetail from '../../components/SizeDetail.vue';
import PiecesDetail from '../../components/PiecesDetail.vue';
import FabricSummary from '../../components/FabricSummary.vue';
import { type Style } from '../../common/CatalogItem';
import { type Assembly } from '../../common/Assembly';
import {
  type PricedProduct,
  type PricedProductSize,
} from '../../common/Product';
import type { Fabric, LiningOption } from '@agon/shared-utils';
import FavoriteButton from '../../components/FavoriteButton.vue';

interface Props {
  culture: string;
  currency: string;
  blobDomain: string;
  designId: string;
  styleId: string;
  fabricId: string;
  liningId: string;
  style: Style;
  assembly: Assembly;
  fabrics: Fabric[];
  liningOptions: LiningOption[];
  products: PricedProduct[];
  showDisplayCurrency: boolean;
  displayCurrency: string;
  displayExchangeRate: string;
  xsrfTokenInput: string;
  xsrfToken: string;
  inventory: Record<string, number>;
  isSalesRep: boolean;
  isAuthenticated: boolean;
  favorites: string[];
}

const props = defineProps<Props>();
const qtyOptions = [
  { text: '0', value: '0' },
  { text: '1', value: '1' },
  { text: '2', value: '2' },
  { text: '3', value: '3' },
  { text: '4', value: '4' },
  { text: '5', value: '5' },
  { text: '6', value: '6' },
  { text: '7', value: '7' },
  { text: '8', value: '8' },
  { text: '9', value: '9' },
  { text: '10+', value: '10' },
];

interface Quantity {
  personalizations: string[];
  showDropdown: boolean;
  qty: number;
}
interface Data {
  thumbnailView: string;
  quantities: Record<string, Quantity>;
  product?: PricedProduct;
  sizes: PricedProductSize[];
  sizeQty: Record<string, number>;
  liningId: string;
  fabricId: string;
  recaptchaToken: string;
  favorites: string[];
}

const data = reactive<Data>({
  thumbnailView: 'front',
  quantities: {},
  sizes: [],
  sizeQty: {},
  liningId: props.liningId,
  fabricId: props.fabricId,
  recaptchaToken: 'none',
  favorites: props.favorites,
});

const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

const recaptcha = async (e) => {
  e.preventDefault();
  // (optional) Wait until recaptcha has been loaded.
  await recaptchaLoaded();

  // Execute reCAPTCHA with action "cartadd".
  data.recaptchaToken = await executeRecaptcha('cartadd');

  // Do stuff with the received token.
  setTimeout(() => {
    //console.log(data.recaptchaToken);
    document.forms['cartForm']?.submit();
  }, 250);
};

const displayExchangeRate = computed(() => Number(props.displayExchangeRate));
const isGrabBag = computed(() => props.designId === 'agbxxxxxx');
const mode = computed(() => (isGrabBag.value ? 'Grab Bag' : 'Overstock'));
const message = computed(() =>
  isGrabBag.value
    ? 'Grab bag items are offered at a steep discount.'
    : 'Overstock items are offered at extreme discounts.',
);

const updateQuantity = () => {
  for (const key in data.quantities) {
    //console.log('updateQuantity: ' + key + ', ' + this.quantities[key].qty);
    data.quantities[key].personalizations = new Array(
      Number(data.quantities[key].qty),
    );
    data.quantities[key].showDropdown = data.quantities[key].qty < 10;
  }
};

const imgUrl = (thumbnailView: string) =>
  `${props.blobDomain}static/style/${props.style.agonswimId}/${props.style.assembly}-view-${thumbnailView}.svg`;

const updateProduct = () => {
  if (productId.value.length === 7) {
    const foundProduct = props.products.find((p) => {
      return p.product.id === productId.value;
    });
    if (!foundProduct) {
      data.product = undefined;
      data.quantities = {};
      return;
    }
    data.product = foundProduct;
    data.quantities = orderBy(foundProduct.product.sizes, 'order').reduce<
      Record<string, Quantity>
    >((result, value) => {
      result[catalogProductId.value + value.id] = {
        personalizations: [],
        qty: foundProduct.product.sizes.length === 1 ? 1 : 0,
        showDropdown: true,
      };
      return result;
    }, {});
  } else {
    data.product = undefined;
  }
};

const toggleFavorite = (itemId: string) => {
  data.favorites = data.favorites.includes(itemId)
    ? data.favorites.filter((f) => f !== itemId)
    : [...data.favorites, itemId];
};

const localize = (dict: Record<string, string>) =>
  genLocalize(props.culture, dict);

const isSubmitDisabled = computed(() => {
  if (!data.quantities) return true;
  return Object.values(data.quantities).every((v) => v === null || v.qty === 0);
});

const productId = computed(
  () => `${props.style.agonswimId}${data.liningId}${data.fabricId}`,
);
const catalogProductId = computed(() => `${props.designId}${productId.value}`);
const isFavorite = computed(() =>
  data.favorites.includes(catalogProductId.value),
);
const isProductUnavailable = computed(() => {
  if (productId.value.length !== 7) return true;
  if (productId.value.indexOf('unk') !== -1) return true;
  if (!data.product) return true;
  return (
    (data.product.product == null || data.product.product.sizes.length === 0) &&
    productId.value.length === 7
  );
});

const asCurrency = (input: number) =>
  input.toLocaleString(props.culture, {
    style: 'currency',
    currency: props.currency,
  });

const asDisplayCurrency = (input: number) =>
  input.toLocaleString(props.culture, {
    style: 'currency',
    currency: props.displayCurrency,
  });

onBeforeMount(() => updateProduct());
</script>
